import {useDispatch, useSelector} from "react-redux";
import {FIELD_LIST_MAIN_BANNER_AVO_STORIES_2} from "../../utils/input-field-list-static-page";
import {setAvoStories2ErrorMessage, setAvoStories2MainBannerDetail} from "../../reducers/avo-stories-2.reducer";
import {useEffect} from "react";
import FormGeneralComponent from "../../components/static-page/form-general.component";
import {useFetch} from "../../services/useFetch";
import {API} from "../../services/api";
import {setToolsAlertMessage, setToolsAlertType, setToolsModalVisibility} from "../../reducers/tools.reducer";
import {convertErrorMessage} from "../../utils/general-variable";

const MainBanner = () => {
    const dispatch = useDispatch()
    const {mainBannerDetail, avoStories2ErrorMessage} = useSelector(state => state.avoStories2Reducer)
    const {fetching: getMainBanner} = useFetch(API.AVO_STORIES_2_GET_MAIN_BANNER)
    const {fetching: updateMainBanner, isLoading} = useFetch(API.AVO_STORIES_2_UPDATE_MAIN_BANNER)
    let fieldList = FIELD_LIST_MAIN_BANNER_AVO_STORIES_2
    let showMainBanner = {
        label: 'Main Banner',
        key: 'show_main_banner',
        activeText: 'Show',
        inActiveText: 'Hide',
        positionText: 'left'
    }

    const onChange = (key, value) => {
        dispatch(setAvoStories2MainBannerDetail({[key]: value}))
    }

    const onSubmitHandler = (e) => {
        e.preventDefault()
        updateMainBanner(mainBannerDetail).then(response => {
            dispatch(setAvoStories2ErrorMessage({}))
            dispatch(setToolsModalVisibility({alert: true}))
            dispatch(setToolsAlertType('success'))
            dispatch(setToolsAlertMessage('Main Banner Updated'))
            dispatch(setAvoStories2MainBannerDetail(response?.data))
        }).catch(err => {
            dispatch(setAvoStories2ErrorMessage(convertErrorMessage(err)))
        })
    }

    useEffect(() => {
        getMainBanner().then(response => {
            dispatch(setAvoStories2MainBannerDetail(response?.data))
        })

        return () => {
            dispatch(setAvoStories2ErrorMessage({}))
        }
    }, [])

    return (
        <FormGeneralComponent
            data={mainBannerDetail}
            switchToggleField={showMainBanner}
            fieldList={fieldList}
            onChange={onChange}
            onSubmitHandler={onSubmitHandler}
            inputClassName={'grid grid-cols-2 gap-x-16 gap-y-4'}
            errorMessage={avoStories2ErrorMessage}
            isLoading={isLoading}
        />
    )
}

export default MainBanner
